import { Stack, Typography } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import BuildIcon from '@mui/icons-material/Build';
import { COLORS } from '../../utils/Application_Constants';

function CorrectionsBadge() {
    return (
        <Stack direction="row" alignItems="center" spacing={0.5} justifyContent="right">
            <Tooltip title="This booking has corrections">
                <BuildIcon
                    sx={{
                        color: COLORS.LT_POMEGRANATE75,
                        verticalAlign: 'middle',
                        width: 19,
                        height: 19,
                    }}
                />
            </Tooltip>
            <Typography
                sx={{ color: COLORS.LT_MIDNIGHT75, mt: '2px !important' }}
                component="span"
                fontWeight="normal"
            >
                Correction
            </Typography>
        </Stack>
    );
}

export default CorrectionsBadge;
